<template>
  <div class="mobile_download_lists">
    <div class="game_list">
      <div class="game_list_body">
        <img class="game_icon" src="http://wx.52bjd.com/assets/hongwang/pcdown/img/09.png" alt="">
        <div class="game_info">
          <div class="game_title">
            白金岛游戏大厅
            <img class="title_icon" src="~@/assets/image/download/mobile/title_icon.png" alt="">
          </div>
          <p class="game_desc">大厅合集版，跑得快、红中血流、三打哈、全民捕鱼、打地鼠、跑胡子、歪胡子、长沙/转转麻将、放炮罚等，各地地方玩法应有尽有。</p>
          <!-- <p class="game_desc">102万下载 36.2M</p> -->
        </div>
        <div class="game_download_btn_list">
          <a class="download_btn_ios" @click="download_ios"></a>
          <a class="download_btn_android" href="https://download.52bjd.com/pdk/pdk_52bjd.apk" ></a>
        </div>
        <div class="game_download_qrcode">
            <img class="game_download_qrcode_img" src="~@/assets/image/mobile_site.png" alt="">
            <!-- <div class="qrcode_desc">微信扫一扫下载</div> -->
        </div>
      </div>
    </div>
    <div class="game_list">
      <div class="game_list_body">
        <img class="game_icon" src="https://wx.52bjd.com/assets/hongwang/pcdown/img/08.png" alt="">
        <div class="game_info">
          <div class="game_title">
            白金岛三打哈
            <img class="title_icon" src="~@/assets/image/download/mobile/title_icon.png" alt="">
          </div>
          <p class="game_desc">大厅合集版，原三打哈、湘潭三打哈老游戏包用户下载此包，此包账号与上面包体微信登录账号不通（转上面包体建议先绑定手机后使用手机登录）</p>
          <!-- <p class="game_desc">102万下载 36.2M</p> -->
        </div>
        <div class="game_download_btn_list">
          <a class="download_btn_ios" @click="download_ios"></a>
          <a class="download_btn_android" href="https://download.52bjd.com/sdh/sdh_52bjd.apk"></a>
        </div>
        <div class="game_download_qrcode">
            <img class="game_download_qrcode_img" src="~@/assets/image/mobile_site.png" alt="">
            <!-- <div class="qrcode_desc">微信扫一扫下载</div> -->
        </div>
      </div>
    </div>
    <div class="game_list">
      <div class="game_list_body">
        <img class="game_icon" src="~@/assets/image/download/csmj_icon.png" alt="">
        <div class="game_info">
          <div class="game_title">
            白金岛长沙麻将
            <img class="title_icon" src="~@/assets/image/download/mobile/title_icon.png" alt="">
          </div>
          <p class="game_desc">长沙麻将、转转麻将、红中麻将、红中血流麻将、斗地主、跑得快。</p>
          <!-- <p class="game_desc">102万下载 36.2M</p> -->
        </div>
        <div class="game_download_btn_list">
          <a class="download_btn_ios" @click="download_ios"></a>
          <a class="download_btn_android" href="https://download.52bjd.com/csmj/csmj_52bjd.apk"></a>
        </div>
        <div class="game_download_qrcode">
            <img class="game_download_qrcode_img" src="~@/assets/image/download/mobile/csmj_qrcode.png" alt="">
            <!-- <div class="qrcode_desc">微信扫一扫下载</div> -->
        </div>
      </div>
    </div>
    <div class="game_list">
      <div class="game_list_body">
        <img class="game_icon" src="~@/assets/image/download/phz_icon.png" alt="">
        <div class="game_info">
          <div class="game_title">
            合集字牌
            <img class="title_icon" src="~@/assets/image/download/mobile/title_icon.png" alt="">
          </div>
          <p class="game_desc">包含:跑胡子、歪胡子、放炮罚、十胡卡、六胡抢、郴州字牌、碰胡子、邵阳字牌等，地道家乡字牌玩法。</p>
          <!-- <p class="game_desc">102万下载 36.2M</p> -->
        </div>
        <div class="game_download_btn_list">
          <a class="download_btn_ios" @click="download_ios"></a>
          <a class="download_btn_android" href="https://download.52bjd.com/phz/PHZ_52bjd.apk"></a>
        </div>
        <div class="game_download_qrcode">
            <img class="game_download_qrcode_img" src="~@/assets/image/mobile_site.png" alt="">
            <!-- <div class="qrcode_desc">微信扫一扫下载</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    download_ios () {
      const h = this.$createElement
      this.$msgbox({
        title: '下载提示',
        message: h('p', null, [
          h('p', {style: 'text-align:center;font-size: 27px'}, '使用苹果手机扫描右侧二维码下载游戏')
        ]),
        showCancelButton: false,
        showConfirmButton: false,
        customClass: 'slts_box',
        callback: action => {}
      })
    }
  },
  computed: {
  },
  created () {
  }
}
</script>
<style scoped>

.mobile_download_lists .game_list {
  width: 100%;
  height: 150px;
  background-color: #ebebeb;
  margin-bottom: 40px;
  position: relative;
}
.game_list .game_list_body {
  position: absolute;
  width: 100%;
  height: 110px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  padding-left: 35px;
}

.game_list_body .game_icon {
  height: 100%;
  float: left;
}

.game_list_body .game_info {
  width: 735px;
  float: left;
  margin-left: 30px;
}

.game_list_body .game_info .game_title {
  height: 50px;
  font-size: 22px;
  position: relative;
  line-height: 50px;
}

.game_info .game_title .title_icon {
  width: 30px;
  height: 16px;
  position: absolute;
  top: 20px;
  margin-left: 5px;
}

.game_info .game_desc {
  /* height: 25px; */
  padding-right: 20px;
  color: #969696;
  font-size: 18px;
  line-height: 25px;
}

.game_download_btn_list {
  display: block;
  width: 170px;
  height: 100%;
  float: left;
  position: relative;
}

.game_download_btn_list .download_btn_android {
  display: block;
  position: absolute;
  top: 65px;
  width: 100%;
  height: 46px;
  background-image: url('~@/assets/image/download/mobile/android_btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.download_btn_android:hover {
  background-image: url('~@/assets/image/download/mobile/android_btn_1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.game_download_btn_list .download_btn_ios {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 46px;
  margin-bottom: 10px;
  background-image: url('~@/assets/image/download/mobile/ios_btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.download_btn_ios:hover {
  background-image: url('~@/assets/image/download/mobile/ios_btn_1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.mobile_download_lists .game_download_qrcode {
  width: 150px;
  height: 100%;
  float: right;
  margin-right: 10px;
  position: relative;
}

.game_download_qrcode_img {
  position: absolute;
  width: 120px;
  top: -3px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.game_download_qrcode .qrcode_desc {
  color: #969696;
  font-size: 15px;
  position: absolute;
  text-align: center;
  top: 95px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/views/download/children/Mobile.vue